export class AddNewPolicyMdl{
    public PolicyType:string;
    public VehicleDefionitionType:string;
    public IqamaNo:string;
    public CustomerId:string;
    public SequenceNo:string;
    public OwnerIqamaNo:string;
    public CustomerIssueDate:string;
    public Transfer:boolean;
    public isTransferOfOwnership:boolean
    public ProductType:string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/AddNewPolicy.ts